module.exports = __webpack_public_path__ + "024f8abf00e18761f6bddc22686cfc7b.svg";